export enum TiposAlerta {
    HTTP = "http"
}

export enum NivelAlerta {
    SUCCESS = 1,
    WARNING = 2,
    INFO = 3,
    ERROR = 4
}